import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Dispatch } from 'src/config/rootStore';
import { navigationService } from 'src/config/rootService';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import logoImg from 'src/public/img/mh-logo-text.svg';
import { color, font } from 'src/shared/styles/variables';
import img from 'src/shared/svg/welcome-magic-link/paperplane.svg';

const BrandImage = styled.img({
    marginLeft: 32,
    marginTop: 20,
    width: '15em',
    cursor: 'pointer',
    marginRight: 12,
});
const Title = styled.h1(
    {
        color: color.ebonyClay,
        lineHeight: '28px',
        textAlign: 'center',
        paddingBottom: '8px',
        paddingTop: '12px',
        margin: 0,
        width: '100%',
    },
    font.heavy(font.size.extraLarge),
);
const TextBlock = styled.div(
    {
        color: color.blueBayoux,
        lineHeight: '24px',
        marginBottom: 0,
        textAlign: 'center',
        width: '100%',
    },
    font.book(font.size.medium),
);
const Link = styled('a')(
    {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: color.royalBlue,
        '&:hover': {
            textDecoration: 'underline',
            color: color.royalBlue,
        },
    },
    font.book(font.size.medium),
);
const ActionContainer = styled.div({
    paddingTop: '100px',
    textAlign: 'center',
});
const Content = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: '500px',
    flexGrow: 1,
});
const Container = styled.div({
    display: 'flex',
    paddingTop: '72px',
    justifyContent: 'center',
    alignItems: 'start',
    flexGrow: 1,
});
export enum PreferredEmailPageTestId {
    EmailField = 'PreferredEmailPageTestId.EmailField',
    ChangeEmailButton = 'PreferredEmailPageTestId.ChangeEmailButton',
    ContinueButton = 'PreferredEmailPageTestId.SubmitButton',
}
export const PreferredEmailSentPage: React.FC = () => {
    const [emailSent, setEmailSent] = useState(false);
    const user = useSelector(getUserInformation);
    const dispatch: Dispatch = useDispatch();
    const { t } = useTranslation();
    const helpCenterUrl = t('user:help_center.complete_url');

    useEffect(() => {
        if (user.ssoOnly) {
            navigationService.navigate('/completion-page');
        }
    }, [user.ssoOnly]);

    const handleSubmit = () => {
        if (emailSent) {
            window.open(helpCenterUrl, '_blank');
        } else {
            setEmailSent(true);
            dispatch.user.updateEmailAddress(user.newEmailAddressNotConfirmed);
        }
    };

    return (
        <>
            <BrandImage
                src={logoImg}
                onClick={() => {
                    window.location.href = 'https://www.modernhealth.com';
                }}
            />
            <Container>
                <Content>
                    <img src={img} alt="" />
                    <Title>{t('auth:preferred_email_sent.title')}</Title>
                    <TextBlock>
                        {t('auth:preferred_email_sent.subtitle', {
                            email: user.newEmailAddressNotConfirmed,
                        })}
                    </TextBlock>
                    <ActionContainer>
                        <TextBlock>
                            {emailSent
                                ? t('auth:preferred_email_sent.we_sent_another_verification_email')
                                : t('auth:preferred_email_sent.did_not_get_the_email')}
                        </TextBlock>
                        <Link onClick={handleSubmit}>
                            {emailSent
                                ? t('auth:preferred_email_sent.need_help')
                                : t('auth:preferred_email_sent.resend_verification_email')}
                        </Link>
                    </ActionContainer>
                </Content>
            </Container>
        </>
    );
};
